import {RouteRecordRaw} from "vue-router";
import AchievementsIndexPage from '../pages/IndexPage.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/achievements',
    name: 'achievements.index',
    component: AchievementsIndexPage,
  }
];